
import { WorldCountry } from './types';

export const lebanonData: WorldCountry = {
  code: 'LB',
  name: 'Lebanon',
  slug: 'lebanon',
  population: 6825445,
  topCities: [
    { name: 'Beirut', slug: 'beirut', population: 2385000 },
    { name: 'Tripoli', slug: 'tripoli', population: 229398 },
    { name: 'Sidon', slug: 'sidon', population: 163554 },
    { name: 'Tyre', slug: 'tyre', population: 135204 },
    { name: 'Nabatieh', slug: 'nabatieh', population: 120000 },
    { name: 'Jounieh', slug: 'jounieh', population: 100523 },
    { name: 'Zahle', slug: 'zahle', population: 78145 },
    { name: 'Baalbek', slug: 'baalbek', population: 82608 },
    { name: 'Byblos', slug: 'byblos', population: 40000 },
    { name: 'Aley', slug: 'aley', population: 45000 }
  ]
};
